import ImageCompanyLogo from '@/components/ImageCompanyLogo'
import React, {
    useState, useEffect, forwardRef, useImperativeHandle,
  } from 'react'
  
  const MentionList =  ((props, ref) => {
    const [selectedIndex, setSelectedIndex] = useState(0)
  
    const selectItem = index => {
      const item = props.items[index]
  
      if (item) {
        props.command({ id: item })
      }
    }
  
    const upHandler = () => {
      setSelectedIndex((selectedIndex + props.items.length - 1) % props.items.length)
    }
  
    const downHandler = () => {
      setSelectedIndex((selectedIndex + 1) % props.items.length)
    }
  
    const enterHandler = () => {
      selectItem(selectedIndex)
    }
  
    useEffect(() => setSelectedIndex(0), [props.items])
  
    useImperativeHandle(ref, () => ({
      onKeyDown: ({ event }) => {
        if (event.key === 'ArrowUp') {
          upHandler()
          return true
        }
  
        if (event.key === 'ArrowDown') {
          downHandler()
          return true
        }
  
        if (event.key === 'Enter') {
          enterHandler()
          return true
        }
  
        return false
      },
    }))
  
    return (
      <div className='mds-dropdown ' >
        <div className="items dropdown-menu show" style={{maxHeight: "200px", overflowY :"scroll"}}>
        {props.items && props.items.length
          ? props.items.map((item, index) => (
            <button
              className={`item dropdown-item ${index === selectedIndex ? 'is-selected' : ''}`}
              key={index}
              onClick={() => selectItem(index)}
            >
              <div className='d-flex gap-2 align-items-center'>
              <ImageCompanyLogo className="rounded-circle" width={16} height={16} company={item} />
              <span className='text-capitalize'>{item.companyName}</span>
              </div>
            </button>
          ))
          : <div className="item dropdown-item">No result</div>
        }
      </div>
      </div>
    )
  })



  export default forwardRef(MentionList);